import React from "react"
import { LANDING_COPY } from "../../../docs/catalog"
import type { IntegrationType } from "../../../docs/types"

// The integration type (contract v9): "Package", "Plugin", "Guide", "Recipe"
// or "Via BTCPay Server", from the row's `type`. It tells a visitor what they
// get before they click, so a recipe never passes for a package. A bundle
// older than v9 has no type, and the card is drawn as before.
export const IntegrationTypeBadge: React.FC<{ type: IntegrationType | null; className?: string }> = ({
  type,
  className
}) => {
  const copy = type ? LANDING_COPY.integrations.types[type] : null
  if (!copy) return null
  return (
    <span className={["or-type-badge", className].filter(Boolean).join(" ")} data-type={type} title={copy.title}>
      {copy.label}
    </span>
  )
}
